import PoliciesActionsList from './PoliciesActionsList';
export default PoliciesActionsList;
